import React, { useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Loader } from 'components';
import { assessmentActions, httpRequestsOnErrorsActions, httpRequestsOnSuccessActions } from 'store';
import { FindLoad, useModal, FindSuccessItem } from 'utils';

export const GoAssessment = ({ info, requestParams }) => {
    const ACTION_TYPE = 'CREATE_ASSESSMENT';
    const client = useSelector((state) => state.client.clientItemInfo);
    const dispatch = useDispatch();
    const success = FindSuccessItem(ACTION_TYPE);
    const loader = FindLoad(ACTION_TYPE);
    const { open } = useModal();

    useEffect(() => {
        dispatch(httpRequestsOnErrorsActions.removeError(ACTION_TYPE));
    }, []);

    useEffect(() => {
        if (info) {
            reset(info);
        }
    }, [info]);

    const VbmappIframeEmbed = ({ token, learnerId }) => {
        const mountRef = useRef(null);

        useEffect(() => {
            const script = document.createElement('script');
            script.src = 'https://api-sandbox.vbmappapp.com/javascripts/iframe_support.js';
            script.onload = () => {
                if (window.openAssessmentIframe && mountRef.current) {
                    window.openAssessmentIframe('dmtd-rest-api', 'en', token, 'vbmapp', learnerId, null, mountRef.current);
                }
            };
            document.head.appendChild(script);
        }, [token, learnerId]);

        useEffect(() => {
            return () => {
                dispatch(assessmentActions.saveAssessment(client?.id, requestParams));
            };
        }, []);

        return <div ref={mountRef} style={{ height: '90vh', width: '90vw' }} />;
    };

    useEffect(() => {
        if (success) {
            open(<VbmappIframeEmbed token={success?.data?.token} learnerId={success?.data?.learnerId} />, {
                styles: {
                    wrapperStyle: { padding: '0px', borderRadius: '8px' },
                    bodyStyle: { padding: '0px', borderRadius: '8px' },
                },
            });
            dispatch(httpRequestsOnSuccessActions.removeSuccess(ACTION_TYPE));
        }
    }, [success]);

    useEffect(() => {
        dispatch(assessmentActions.createAssessment(client?.id));
    }, []);

    return <div style={{ height: '90vh', width: '90vw' }}>{loader?.length && <Loader />}</div>;
};
